module.exports = __webpack_public_path__ + "static/media/logo.d6fe2ff5.svg";